<template>
  <div class="col-span-4">
    <p class="text-gray-500 ske whitespace-nowrap">
      <span class="font-medium text-gray-900 truncate" style="max-width: 90px" :title="user && user.name">{{ user && user.name || 'ashtasht' }}</span>
      <span class="ml-1">heeft de </span>
      <span class="ml-1">{{ formatedPageType || 'ashashtashtast' }}</span>
      <span
        class="ml-1 truncate"

        style="max-width: 135px"
        :class="itemName ? 'font-medium text-gray-900' : 'italic'"
        :title="itemName"
      >
        <a v-if="itemLink && itemName" :href="itemLink" class="text-blue-600 hover:underline" target="_blank">
          {{ itemName || 'unknown' }}
        </a>
        <span v-else>
          {{ itemName || 'unknown' }}
        </span>
      </span>
      <span class="ml-1">{{ actionType || 'ashtasht' }}</span>
    </p>
  </div>
</template>

<script>

const pageWithLinks = ['websites', 'products', 'orders']

import { translatePageName } from "@/utils/audit-trail"

export default {
  props: {
    user: Object,
    page: String,
    itemName: String,
    itemId: String,
    event: String,
  },
  computed: {
    itemLink() {
      if (pageWithLinks.includes(this.page)) {
        return `/admin/${
          {
            'products': 'product/edit',
            'orders': 'order',
            'websites': 'websites/edit',
          }[this.page]
        }/${this.itemId}`
      }
    },
    actionType() {
      switch (this.event) {
        case "create": return "gemaakt"
        case "update": return "bijgewerkt"
        case "delete": return "verwijderd"
      }
    },
    formatedPageType() {
      return translatePageName(this.page)
    },
  },
}

</script>

<style scoped>

p {
  font-size: 12px;
}

</style>

